import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Modal } from 'react-bootstrap';

import CollectionList from './CollectionList';
import Icon from './Icon';
import BookController from '../controllers/BookController';
import CollectionController from '../controllers/CollectionController';
import NoteController from '../controllers/NoteController';

export default class DashboardSidebar extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(type) {
    this.setState({ show: true, type });
  }

  getForm() {
    switch (this.state.type) {
      case 'collection':
        return <CollectionController onSave={this.handleClose} />;
      case 'note':
        return <NoteController onSave={this.handleClose} />;
      case 'book':
        return <BookController onSave={this.handleClose} />;
      default:
        return null;
    }
  }

  render() {
    const form = this.getForm();
    const navigationBase = this.props.navigationBase || '';

    return (<div className='navigation-menu primary-navigation'>
      <ul className='navigation-menu-list'>
        <li><Link to='/'><Icon name='list-alt'/> Posts</Link></li>
        <li><Link to='/inbox'><Icon name='inbox'/> Inbox</Link></li>
        <li><Link to='/notes'><Icon name='pushpin'/> Notes</Link></li>
        <li><Link to='/incoming-ocr'><Icon name='book'/> OCR</Link></li>
      </ul>
      <CollectionList collections={this.props.collections} />
      <ul className='navigation-menu-list'>
        <li className='list-title'>Create</li>
        <li>
          <Link onClick={(e) => this.handleShow('collection')} to='#'>
            New Collection
          </Link>
        </li>
        <li>
          <Link onClick={(e) => this.handleShow('note')} to='#'>
            New Note
          </Link>
        </li>
        {false && <li>
          <Link onClick={(e) => this.handleShow('book')} to='#'>
            New Book
          </Link>
        </li>}
        <li>
          <Link to={`${navigationBase}/write`}>
            New Post
          </Link>
        </li>
      </ul>
      {false && <ul className='navigation-menu-list'>
        <li className='list-title'>Books</li>
        {this.props.books.map((b) => <li><Link to={`/book/${b.id}`}>{b.name}</Link></li>)}
      </ul>}
      <Modal show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add new {this.state.type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {form}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/DashboardSidebar.js